// Redux store configuration

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import productsReducer from './productsSlice';
import accountsReducer from './accountsSlice';
import searchReducer from './searchSlice';
import dailyReportReducer from './dailyReportSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    accounts: accountsReducer,
    search: searchReducer,
    dailyReport: dailyReportReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

// Infer types from store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
